// src/components/Dialogs/DeleteChatDialog.tsx
import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Box,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";

interface DeleteChatDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: theme.palette.background.paper,
          background: theme.palette.background.paper,
          padding: "16px",
        },
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <WarningAmberOutlinedIcon
            style={{
              marginBottom: 16,
              color: theme.palette.secondary.main,
            }}
          />
          <Typography variant="h6" style={{ fontWeight: 600 }}>
            ลบการสนทนา
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Typography variant="body2" align="center">
            คุณยืนยันที่จะลบการสนทนานี้หรือไม่?
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%" gap={2}>
          <Button
            onClick={onClose}
            color="primary"
            variant="outlined"
            fullWidth
          >
            ยกเลิก
          </Button>
          <Button
            onClick={onConfirm}
            color="secondary"
            variant="contained"
            fullWidth
          >
            ยืนยัน
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
